function RankReward(){

    return <div className={'rankPopup'}>

        <div className={'rankPopupTitle'}><div className={'rankPopupTitleText'}>Rank Reward</div></div>

        <div className={'rankPopupTextContainer rankRewardContainer'}>

            <div className={'rankRewardFirstText'}>The rewards will be credited at the end of the current season,<br /> which is expected to be around August.</div>

            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon bronzeRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>100</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
            </div>
            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon silverRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>500</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
            </div>
            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon goldRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>1000</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
            </div>
            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon platinumRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>1500</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
            </div>
            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon diamondRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>3000</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
            </div>
            <div className={'rankRewardPosition'}>
                <div className={'rankRewardIcon championsRank'}></div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>5000</div>
                    <div className={'rankRewardGemIcon'}></div>
                </div>
                <div className={'rankRewardTextContainer'}>
                    <div className={'rankRewardText'}>20</div>
                    <div className={'rankRewardDivineIcon'}></div>
                </div>
            </div>

        </div>
    </div>
}

export default RankReward;